import { Button } from '../../../components/ui/button';
import { Star, Plus, Edit, Trash2, MessageSquare } from 'lucide-react';

export default function CMSTestimonialsTab({ 
  testimonials, 
  onAdd, 
  onEdit, 
  onDelete 
}) {
  return (
    <div className="bg-white rounded-2xl p-6 shadow-sm">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="font-bold text-slate-900 font-[Poppins]">Customer Reviews</h3>
          <p className="text-sm text-slate-500">Testimonials displayed on your website</p>
        </div>
        <Button 
          onClick={onAdd}
          className="bg-amber-500 hover:bg-amber-600 text-slate-900"
          data-testid="add-testimonial-btn"
        >
          <Plus className="w-4 h-4 mr-2" />
          Add Review
        </Button>
      </div>
      
      <div className="grid md:grid-cols-2 gap-4">
        {testimonials.length === 0 ? (
          <div className="col-span-2 text-center py-12 border-2 border-dashed border-stone-200 rounded-xl">
            <MessageSquare className="w-12 h-12 text-stone-300 mx-auto mb-3" />
            <p className="text-slate-500">No reviews yet</p>
            <p className="text-sm text-slate-400 mt-1">Add customer testimonials to build trust</p>
          </div>
        ) : (
          testimonials.map((testimonial) => (
            <div key={testimonial.id} className={`p-4 border rounded-xl transition-colors ${testimonial.is_active ? 'border-stone-200' : 'border-stone-100 bg-stone-50 opacity-60'}`}>
              <div className="flex items-start justify-between mb-3">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 bg-amber-100 rounded-full flex items-center justify-center text-amber-600 font-bold">
                    {testimonial.name?.charAt(0) || '?'}
                  </div>
                  <div>
                    <p className="font-semibold text-slate-900">{testimonial.name}</p>
                    <p className="text-xs text-slate-500">{testimonial.location}</p>
                  </div>
                </div>
                <div className="flex gap-1">
                  <Button variant="ghost" size="sm" onClick={() => onEdit(testimonial)}>
                    <Edit className="w-4 h-4" />
                  </Button>
                  <Button variant="ghost" size="sm" className="text-red-500" onClick={() => onDelete(testimonial.id)}>
                    <Trash2 className="w-4 h-4" />
                  </Button>
                </div>
              </div>
              <div className="flex mb-2">
                {[...Array(5)].map((_, i) => (
                  <Star key={`star-${testimonial.id}-${i}`} className={`w-4 h-4 ${i < testimonial.rating ? 'text-amber-400 fill-amber-400' : 'text-stone-200'}`} />
                ))}
              </div>
              <p className="text-sm text-slate-600 italic">&quot;{testimonial.text}&quot;</p>
              {!testimonial.is_active && (
                <span className="inline-block mt-2 text-xs px-2 py-1 bg-stone-200 text-stone-600 rounded-full">Hidden</span>
              )}
            </div>
          ))
        )}
      </div>
    </div>
  );
}
